import { Nps } from "@iloq/shared/types/partner-program";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosInstance } from "axios";
import { useAxiosInstance } from "@iloq/shared-react/use-axios-instance.hook";

export const npsAverageQueryKey = "getNpsAverage";

export function getNPSAverageReportsCount(npsAverage: Nps | null | undefined): number {
  return (
    (npsAverage?.detractors?.count ?? 0) +
    (npsAverage?.passives?.count ?? 0) +
    (npsAverage?.promoters?.count ?? 0)
  );
}

function npsAverageQueryFn(axiosInstance: AxiosInstance) {
  return async (): Promise<Nps> => {
    const response = await axiosInstance.get<Nps>("/api/v2/partner-program/nps-average");

    if (response.status !== 200) {
      throw new Error(`Failed to get NPS average: ${response.status} - ${response.statusText}`);
    }

    return response.data;
  };
}

export function useNpsAverageQuery(): UseQueryResult<Nps> {
  const axiosInstance = useAxiosInstance();

  return useQuery({
    queryKey: [npsAverageQueryKey],
    queryFn: npsAverageQueryFn(axiosInstance),
    /* staleTime value of > 0 needed to prevent render loop, when both parent and child use the query,
     * since child calls refetch on mount, which rerenders parent. */
    staleTime: 1000 * 60 * 30, // 30 mins cache
  });
}
